module.exports = __webpack_public_path__ + "static/media/service.6715e0f1.svg";